import { api } from "../Apis/interceptor";

export const all = function (cust_id) {
  return api.get("/api/v1/advisorList/" + cust_id);
};

export const members = function (cust_id, advisor_adv) {
  return api.get("/api/v1/memberList/" + cust_id + "/" + advisor_adv);
};

export const addOrganisation = function (cust_id, organisation) {
  return api.put("/api/v1/addOrganisation/" + cust_id, {
    organisation: organisation,
  });
};

export const getAdvisorsAndOrgs = function (cust_id, branch_id) {
  return api.get("/api/v1/getOrganisations/" + cust_id + "/" + branch_id);
};

export const getSelectedAdvisor = function (cust_id, advisor_id) {
  return api.get("/api/v1/getSelectedAdvisor/" + cust_id + "/" + advisor_id);
};
